export default __webpack_public_path__ + "static/media/Liveme5.b0f42b56.png";